import { Link, useSearchParams } from "react-router-dom";
import { PUBLIC_BASE } from "../../../../shared/lib/routesResolver";
import RestorePasswordForm from "./RestorePasswordForm";
import { useEffect, useState } from "react";

const RestorePasswordContainer = () => {
  const [searchParams] = useSearchParams();
  const [token, setToken] = useState();

  useEffect(() => {
    const restorationToken = searchParams.get("token");
    if (restorationToken) {
      setToken(restorationToken);
    }
  }, []);

  return (
    <div className="mx-auto flex flex-col w-full justify-center space-y-6">
      <div className="flex flex-col space-y-2 text-center">
        <div className="flex justify-center">
          <img
            className="w-1/4"
            src="/login-form-logo.svg"
            alt="ADQUIVER MEDIA"
          />
        </div>
        <h1 className="text-2xl font-semibold tracking-tight">
          Restablecer nueva contraseña
        </h1>
        <p className="text-sm text-muted-foreground">
          Por favor, introduzca su nueva contraseña
        </p>
      </div>
      <RestorePasswordForm token={token} />
      <div className="px-5 text-center text-sm underline text-adq-blue">
        <Link to={PUBLIC_BASE}>Volver al inicio</Link>
      </div>
    </div>
  );
};

export default RestorePasswordContainer;
